<template>
  <div
    style="width: 100%; height: 100%"
    ref="chartsDom"
    class="chartsDom"
  ></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "chartsDom",
  props: {
    list: Object,
  },
  data() {
    return {
      goToSchoolTwo: {},
    };
  },
  watch: {
    list: {
      handler(newVal, oldVal) {
        this.goToSchoolTwo = newVal;
        if (true) {
          this.$nextTick(() => {
            this.initNYNM();
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.goToSchoolTwo = this.list;
    this.$nextTick(() => {
      this.initNYNM();
    });
    window.addEventListener("resize", () => {
      this.$echarts.init(this.$refs.chartsDom).resize();
    });
  },
  methods: {
    initNYNM() {
      // 基于准备好的dom，初始化echarts实例
      // 绘制图表

      let myChart = this.$echarts.init(this.$refs.chartsDom);
      // 2. 指定配置和数据

      let goToSchoolTwo = this.goToSchoolTwo;
      let serieslist = [];
      let colors = ["#00AFF6", "#4B9BFF", "#CF0913"];
      let areaColors = [
        [
          { offset: 0, color: "rgba(0, 224, 219, 0.40)" },
          { offset: 0.9, color: "rgba(0, 194, 255, 0.1)" },
          { offset: 1, color: "rgba(0, 194, 255, 0)" },
        ],
        [
          { offset: 0, color: "rgba(0, 111, 255, 0.40)" },
          { offset: 0.9, color: "rgba(0, 194, 255, 0.1)" },
          { offset: 1, color: "rgba(0, 194, 255, 0)" },
        ],
        [
          { offset: 0, color: "rgba(224, 0, 0, 0.40)" },
          { offset: 0.9, color: "rgba(255, 0, 0, 0.1)" },
          { offset: 1, color: "rgba(255, 0, 0, 0)" },
        ],
        [
          { offset: 0, color: "rgba(80, 178, 255, 1)" },
          { offset: 0.9, color: "rgba(5, 115, 255, 0.10)" },
          { offset: 1, color: "rgba(68, 173, 255, 0)" },
        ],
      ];
      goToSchoolTwo.yData.map((item, index) => {
        let i = {
          name: goToSchoolTwo.xData[1][index],
          type: "line",
          showAllSymbol: true,

          itemStyle: {
            symbolSize: 0,
            color: "#00F2FC",
          },
          smooth: true,
          tooltip: {
            show: true,
          },
          lineStyle: {
            color: colors[index],
            symbolSize: 10,
          },
          itemStyle: {
            color: colors[index],
          },
          // areaStyle: {
          //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, areaColors[index])
          // },
          data: item,
        };
        let i1 = {
          name: goToSchoolTwo.xData[1][index],
          type: "bar",
          showBackground: true,
          itemStyle: {
            color: "rgba(220, 125, 125, 0)",
          },
          label: {
            show: true,
            position: "top",
            color: "#fff",
          },
          backgroundStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(69, 217, 255, 0)", // 0% 处的颜色
                },
                {
                  offset: 0.9,
                  color: "rgba(33, 177, 255, 0.2)", // 100% 处的颜色
                },
                {
                  offset: 1,
                  color: "rgba(33, 177, 255, 0.2)", // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
          },
          tooltip: {
            show: false,
          },

          data: item,
        };

        serieslist.push(i);

        serieslist.push(i1);
      });
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(126,199,255,0)", // 0% 处的颜色
                  },
                  {
                    offset: 0.9,
                    color: "rgba(126,199,255,1)", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(126,199,255,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
          textStyle: {
            align: "left",
          },
        },

        legend: {
          // right: "4%",
          top: "8%",
          itemGap: 16,
          itemWidth: 20,
          itemHeight: 6,
          textStyle: {
            color: "rgba(222, 243, 255, 1)",
            fontStyle: "normal",
            fontFamily: "微软雅黑",
            fontSize: 12,
          },
        },
        grid: {
          top: "20%",
          left: "5%",
          right: "5%",
          bottom: "5%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisLine: {
              //坐标轴轴线相关设置。数学上的x轴
              show: true,
              lineStyle: {
                color: "rgba(59, 78, 103, 1)",
              },
            },
            axisLabel: {
              //坐标轴刻度标签的相关设置
              color: "#AAC0C3",
              fontSize: 14,
              formatter: function (data) {
                return data;
              },
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: "#192a44",
              },
            },
            axisTick: {
              show: false,
            },
            data: goToSchoolTwo?.xData[0],
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位：个",
            nameTextStyle: {
              color: "#AAC0C3",
              fontSize: 14,
              padding: 0,
            },
            min: 0,
            splitLine: {
              show: true,
              lineStyle: {
                color: "#BBE0F8",
                opacity: 0.2,
                type: "dashed",
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(59, 78, 103, 1)",
              },
            },
            axisLabel: {
              show: true,
              fontSize: 14,
              color: "#AAC0C3",
              formatter: function (value) {
                if (value === 0) {
                  return value;
                }
                return value;
              },
            },
            axisTick: {
              show: false,
            },
            type: "value",
            position: "left",
          },
        ],
        series: serieslist,
      };
      // 其他各种图表一个原理
      // let index = 0;
      // setInterval(function () {
      //     // 这里的7 为x轴的长度
      //     if (index >= 7) {
      //         index = 0;
      //     }
      //     myChart.dispatchAction({
      //         type: "showTip", // 提示框
      //         seriesIndex: 0,
      //         dataIndex: index // 第 lightIndex 柱子高亮
      //     });
      //     index += 1;
      // }, 2000);
      // 3. 把配置给实例对象
      myChart.setOption(option);
      // 4. 让图表跟随屏幕自动的去适应
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
  },
};
</script>
